import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, retry, switchMap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  token?: string;
  captchaToken?: string;

  constructor(
    public httpClient: HttpClient,
    private configService: ConfigService
  ) {}

  setToken(token: string) {
    this.token = token;
  }

  saveLiteToken(token: string): void {
    window.sessionStorage.removeItem('lite_token');
    window.sessionStorage.setItem('lite_token', token);
  }

  saveUserAuth(document: number, document_type: string): void {
    const data = { document, document_type };
    window.sessionStorage.setItem('user', JSON.stringify(data));
  }

  removeLiteToken() {
    window.sessionStorage.removeItem('lite_token');
    window.sessionStorage.removeItem('user');
  }

  getSessionLiteToken(){
    let token = window.sessionStorage.getItem('lite_token')
  }

  /**
   * This method validates the user's credentials and stores the token in the service
   * @returns Observable<any>
   */
  login(
    documentType: string,
    document: string,
    captcha3v: string
  ): Observable<any> {
    // Rest token on login
    this.token = undefined;
    // let captcha = environment.recaptcha.siteKey;
    let captcha = captcha3v;
    let url = `${environment.serverUrl}/anubis/auth/login/lite/`;
    let body: any = {
      document: document,
      type_document: documentType,
    };

    if (captcha != null && captcha !== '') {
      body['captcha'] = captcha;
    }

    return this.httpClient.post<any>(url, body, {});
  }

  /**
   * Create a new user
   * @returns Observable<any>
   */
  signup(
    documentType: string,
    document: string,
    cellphone: string,
    name: string,
    lastname: string,
    email: string,
    bornDate: string,
    captchaToken: string,
    allow_sms: boolean,
    allow_email: boolean
  ): Observable<any> {
    // Rest token on signup
    let url = `${environment.serverUrl}/crm/signup/`;
    let body: any = {
      document: document,
      document_type: documentType,
      captcha_token: captchaToken,
      cellphone: cellphone,
      email: email,
      name: name,
      lastname: lastname,
      // 'address': address,
      born_date: bornDate,
      allow_sms: allow_sms,
      allow_email: allow_email,
      malls: [this.configService.mall?.id],
    };
    return this.httpClient.post<any>(url, body, {});
  }

  getAuthHeaders() {
    let sessionToken = window.sessionStorage.getItem('lite_token');
    // console.debug('sessionToken', sessionToken);
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + sessionToken,
      }),
    };

    return httpOptions;
  }

  getSimpleAuthHeaders(): HttpHeaders {
    const token = localStorage.getItem('token');
    return new HttpHeaders({
      Authorization: `Bearer ${token}`
    });
  }

  getUserInfo(): Observable<any> {
    let url = `${environment.serverUrl}/anubis/auth/user`;
    return this.httpClient.get<any>(url, this.getAuthHeaders());
  }

  getButtonsRoles(): Observable<any> {
    let url = `${environment.serverUrl}/anubis/roles/role/registry`;
    return this.httpClient.get<any>(url, this.getAuthHeaders());
  }

  getRoleById(id: number): Observable<any> {
    let url = `${environment.serverUrl}/anubis/roles/role/registry/${id}`;
    return this.httpClient.get<any>(url, this.getAuthHeaders());
  }

  saveRol(role_id: number): Observable<any> {
    return this.getUserInfo().pipe(
      switchMap((user) => {
        const userId = user?.id; // Extrae el ID del usuario
        if (!userId) {
          throw new Error('No se encontró el ID del usuario');
        }

        let url = `${environment.serverUrl}/anubis/roles/role/assign/${userId}`;
        return this.httpClient.post<any>(
          url,
          { role_id },
          this.getAuthHeaders()
        );
      })
    );
  }

  assignRoleToChannel(): Observable<any> {
    const url = `${environment.serverUrl}/anubis/roles/role/assign/channel`;
    return this.httpClient.post<any>(url, {}, this.getAuthHeaders());
  }

  validateTokenResume(token: any){
    const url = `${environment.serverUrl}/horus/crm/profile/token/${token}`;
    return this.httpClient.get<any>(url);
  }

  resendToken(actualToken: any){
    const url = `${environment.serverUrl}/thoth/bills/resend-group-email`;
    let body = {
      token: actualToken
    }
    return this.httpClient.post<any>(url, body);
  }

  async getLoginMethods(data: any) {
    const url = environment.serverUrl + '/anubis/auth/login/v2';
    return this.httpClient
      .post(url, data)
      .toPromise()
      .then((data) => {
        return data;
      });
  }

  async sendCode(data: any) {
    const url = environment.serverUrl + '/anubis/auth/login/v2/send-code/';
    return this.httpClient
      .post(url, data)
      .toPromise()
      .then((data) => {
        return data;
      });
  }

  async validateCode(code: string) {
    const url = environment.serverUrl + '/anubis/auth/login/code';
    const httpOptions = this.getAuthHeaders();

    const body = {
      code: code
    }

    return this.httpClient.post(url, body, httpOptions).toPromise().then((data) => {
        return data;
    });
  }

  getContestByRol(): Observable<any> {
    let liteToken = window.sessionStorage.getItem('token') as any;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + liteToken,
    });

    let url = `${environment.serverUrl}/serverless/campaigns/active/`;
    const mall = JSON.parse(window.localStorage.getItem('mall') || '{}');
    const customer_id = mall.id;

    let params: any = {};
    params.customer = customer_id;
    params.channel = window.localStorage.getItem('channel_id') as any;
    return this.httpClient.get<Array<any>>(url, { params, headers }).pipe(retry(2));
  }

}
